export default __webpack_public_path__ + "static/media/contactsBlack.888fb542.svg";